export const shortTransactionNumber = (address: string, length = 8): string => {
  return address.slice(0, length) + '...';
};
